// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';

/* eslint-disable react/prefer-stateless-function */

class CreditMemoCellRenderer extends Component {

    render() {

        return (
            <div className='credit-memo-cell-renderer'>
                <SmartFormLink
                    displayText={this.props.value}
                    formName='CREDITMEMO'
                    objectId={this.props.value}
                />
            </div>
        );

    }

}

CreditMemoCellRenderer.displayName = 'CreditMemoCellRenderer';
CreditMemoCellRenderer.propTypes = {
    value: PropTypes.string.isRequired
};

export default CreditMemoCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/credit-memo-cell-renderer.js